

























































































































































































import _ from 'lodash'
import Vue from 'vue'
import Component, { mixins } from 'vue-class-component'
import { Action, State, Mutation, Getter } from 'vuex-class'
import { Post, PostTranslation } from '@/modules/blog/types'
import * as moment from 'moment'
import SEODetail from '@/modules/seo/components/SEODetail.vue'
import Editor from '@/components/Editor.vue'
import PostPreview from '@/modules/blog/components/PostPreview.vue'
import { MutationTypes } from '@/modules/blog/store/mutations'
import PostSaveConfirm from '@/modules/blog/components/PostSaveConfirm.vue'
import { buildPostSEOCompletor } from '@/modules/blog/util/PostSEOCompletor.ts'
import FeaturedImage from '@/modules/blog/components/FeaturedImage.vue'
import { MediaObject } from '@/modules/media/types'
import I18nMixin from '@/modules/i18n/mixins/I18nMixin'
import TranslationSelect from '@/modules/i18n/components/TranslationSelect.vue';
import Loader from '@/components/Loader.vue';
import TagAutocomplete from '@/modules/blog/components/tag/TagAutocomplete.vue';
import ModerationVoteList from '@/modules/cms/modules/moderation/components/ModerationVoteList.vue';


@Component({
    components: {
        ModerationVoteList,
        TagAutocomplete,
        Loader,
        'seo-detail': SEODetail,
        'editor': Editor,
        'post-preview': PostPreview,
        'save-confirm': PostSaveConfirm,
        FeaturedImage,
        TranslationSelect,
    },
})
export default class PostComponent extends mixins(I18nMixin) {

    public $refs: Vue['$refs'] & {
        previewFrame: HTMLIFrameElement,
        seoDetail: {
            complete (): void,
        },
    }

    @Mutation('showLoadingScreen')
    public showLoadingScreen: (payload: {message: string}) => void

    @Mutation('hideLoadingScreen')
    public hideLoadingScreen: () => void

    @Mutation('blog/setEditingPostTranslation')
    public setTranslation: (translation: PostTranslation) => void

    @Mutation('blog/setEditingPost')
    public setPost: (post: Post) => void

    @Mutation(`blog/${MutationTypes.ActivePostPreview}`)
    public activePreview: (active: boolean) => void

    @Mutation(`blog/${MutationTypes.ShowSaveConfirm}`)
    public showSaveConfirm: (show: boolean) => void

    @Action('blog/loadPost')
    public loadPost: (payload: {post: number, editing: boolean}) => void

    @Mutation('blog/post/current/field/update')
    public updatePost: (payload: {path: string, value: any}) => void

    /**
     * Construye una nueva publicación
     */
    @Action('blog/buildPost')
    public buildPost: (payload: {inEdition: boolean}) => Post

    @Action('blog/loadPostPreview')
    public loadPreview: () => void

    /**
     * Traducción actual
     */
    @Getter('blog/currentEditingPostTranslation')
    public currentTranslation: PostTranslation

    /**
     * Publicación en edición
     */
    @State(state => state.blog.editingPost)
    public post: Post

    public isNew = false
    public loading = true
    public saveConfirmDialog = false
    public fab = false
    public completor = buildPostSEOCompletor()
    public moderationVoteList = false

    public changeImage (image: MediaObject) {
        this.updatePost({
            path: 'featuredImage',
            value: image,
        })
    }

    /**
     * Fecha de creación de la publicación formateada
     */
    get postCreatedAtFormat (): string {
        if (this.isNew) {
            return 'Ahora'
        }

        return moment.unix(this.post.createdAt).format('LLL')
    }

    get postUpdatedAtFormat (): string {
        return moment.unix(this.post.updatedAt).format('LLL')
    }

    /**
     * Actualizar traducción
     *
     * Muta la traducción actual sustituyendola por una copia con el campo y
     * valor argumentados actualizados.
     */
    public updateTranslation (event: {field: string, value: string}) {
        const copy = _.clone(this.currentTranslation)
        this.setTranslation(_.set(copy, event.field, event.value))

        // Completar el SEO
        this.$refs.seoDetail.complete()
    }

    /**
     * Actualizar etiquetas de la publicación
     */
    public updatePostTags (tags: string[]) {
        this.updatePost({path: 'tags', value: tags})

        // // Auto-completa las etiquetas del SEO
        this.$refs.seoDetail.complete()
    }

    public async created () {
        this.loading = true
        const postId = this.$route.params.id

        // Si el id es la palabra 'nueva' se creara una nueva publicación
        if (postId === 'nueva') {
            await this.buildPost({inEdition: true})
            this.isNew = true
        } else {
            // tslint:disable-next-line:radix
            await this.loadPost({post: parseInt(postId), editing: true})
        }

        this.loading = false
    }

    public openPreview () {
        this.activePreview(true)
        this.loadPreview()
    }
}
